import React from "react";
import Header from "../common/Header";
import Footer from "../common/Footer";
import { InterviewDetail } from './PublicFunctions';
import loadingImage from "../../assets/img/loading.gif";
import Meta from "./Meta";
import AdSenseAd250 from "./AdSenseAd160x600";

class Interview extends React.Component {
  constructor() {
    super()
    this.state = {
      posts: [],
      submitted: false,
      isLoading: true
    }
  }

  componentDidMount() {
    const tutorialId = this.props.match.params.tutId;
    InterviewDetail(tutorialId).then(res => {
      this.setState({
        posts: res.data,
        isLoading: false

      })
    })
  }
  render() {
    const tutId = this.props.match.params.tutId;
    let tutname, title, keywords, description;
    const { isLoading, posts } = this.state;
    if (tutId === 'php') {
      tutname = "PHP";
      title = "PHP Interview Question and Answer for Beginners, Learn PHP Step-by-Step, PHP Crash Course";
      keywords = "PHP Interview Question and Answer, PHP Step-by-Step, PHP Crash Course";
      description = "This PHP Interview Question and Answer is for Beginners, if anyone want paid training whatsapp me 9911097721 or call";
    }
    else if (tutId === 'javascript') {
      tutname = "Javascript";
      title = "Javascript Interview Question and Answer for Beginners, Learn Javascript Step-by-Step, Javascript Crash Course";
      keywords = "Javascript Interview Question and Answer, Javascript Step-by-Step, Javascript Crash Course";
      description = "This Javascript Interview Question and Answer is for Beginners, if anyone want paid training whatsapp me 9911097721 or call";
    }
    else if (tutId === 'jquery') {
      tutname = "jQuery";
      title = "jQuery Interview Question and Answer for Beginners, Learn jQuery Step-by-Step, jQuery Crash Course";
      keywords = "jQuery Interview Question and Answer, jQuery Step-by-Step, jQuery Crash Course";
      description = "This jQuery Interview Question and Answer is for Beginners, if anyone want paid training whatsapp me 9911097721 or call";
    }
    else if (tutId === 'ajax') {
      tutname = "Ajax";
      title = "Ajax Interview Question and Answer for Beginners, Learn Ajax Step-by-Step, Ajax Crash Course";
      keywords = "Ajax Interview Question and Answer, jQuery Step-by-Step, Ajax Crash Course";
      description = "This Ajax Interview Question and Answer is for Beginners, if anyone want paid training whatsapp me 9911097721 or call";
    }
    else if (tutId === 'codeigniter') {
      tutname = "Codeigniter";
      title = "Codeigniter Interview Question and Answer for Beginners, Learn Codeigniter Step-by-Step, Codeigniter Crash Course";
      keywords = "Codeigniter Interview Question and Answer, Codeigniter Step-by-Step, Codeigniter Crash Course";
      description = "This Codeigniter Interview Question and Answer is for Beginners, if anyone want paid training whatsapp me 9911097721 or call";
    }
    else if (tutId === 'laravel') {
      tutname = "Laravel";
      title = "Laravel Interview Question and Answer for Beginners, Learn Laravel Step-by-Step, Laravel Crash Course";
      keywords = "Laravel Interview Question and Answer, Laravel Step-by-Step, Laravel Crash Course";
      description = "This Laravel Interview Question and Answer is for Beginners, if anyone want paid training whatsapp me 9911097721 or call";
    }
    else if (tutId === 'api') {
      tutname = "API";
      title = "API Interview Question and Answer for Beginners, API Step-by-Step, API Crash Course";
      keywords = "API Interview Question and Answer, API Step-by-Step, API Crash Course";
      description = "This API Interview Question and Answer is for Beginners, if anyone want paid training whatsapp me 9911097721 or call";
    }
    else if (tutId === 'react') {
      tutname = "ReactJS";
      title = "ReactJS Interview Question and Answer for Beginners, Learn ReactJS Step-by-Step, ReactJS Crash Course";
      keywords = "ReactJS Interview Question and Answer, ReactJS Step-by-Step, ReactJS Crash Course";
      description = "This ReactJS Interview Question and Answer is for Beginners, if anyone want paid training whatsapp me 9911097721 or call";
    }
    else if (tutId === 'node') {
      tutname = "Node";
      title = "Node.js Interview Question and Answer for Beginners, Learn Node Step-by-Step, Node.js Crash Course";
      keywords = "Node.js Interview Question and Answer, Node Step-by-Step, Node.js Crash Course";
      description = "This Node.js Interview Question and Answer is for Beginners, if anyone want paid training whatsapp me 9911097721 or call";
    }
    else if (tutId === 'javascriptchallenges') {
      tutname = "Javascript Challenges";
      title = "Javascript Challenges Interview Question and Answer for Beginners, Learn Javascript Challenges Step-by-Step, Javascript Challenges Crash Course";
      keywords = "Javascript Challenges Interview Question and Answer, Javascript Challenges Step-by-Step, Javascript Challenges Crash Course";
      description = "This Javascript Challenges Interview Question and Answer is for Beginners, if anyone want paid training whatsapp me 9911097721 or call";
    }
    else if (tutId === 'mongodb') {
      tutname = "Mongo DB";
      title = "Mongo DB Interview Question and Answer for Beginners, Learn Mongo DB DBStep-by-Step, Mongo DB Crash Course";
      keywords = "Mongo DB Interview Question and Answer, Mongo DB Step-by-Step, Mongo DB Crash Course";
      description = "This Mongo DB Interview Question and Answer is for Beginners, if anyone want paid training whatsapp me 9911097721 or call";
    }
    else if (tutId === 'database') {
      tutname = "Database";
      title = "Database Interview Question and Answer for Beginners, Learn Database Step-by-Step, Database Crash Course";
      keywords = "Database Interview Question and Answer, Database Step-by-Step, Database Crash Course";
      description = "This Database Interview Question and Answer is for Beginners, if anyone want paid training whatsapp me 9911097721 or call";
    }
    else if (tutId === 'aws') {
      tutname = "AWS";
      title = "AWS Interview Question and Answer for Beginners, Learn AWS Step-by-Step, AWS Crash Course";
      keywords = "AWS Interview Question and Answer, AWS Step-by-Step, AWS Crash Course";
      description = "This AWS Interview Question and Answer is for Beginners, if anyone want paid training whatsapp me 9911097721 or call";
    }
    else if (tutId === 'techlead') {
      tutname = "Tech Lead";
      title = "Tech Lead Interview Question and Answer for Beginners";
      keywords = "Tech Lead Interview Question and Answer";
      description = "This Tech Lead Interview Question and Answer is for Beginners, if anyone want paid training whatsapp me 9911097721 or call";
    }

    return (
      <div>
        {isLoading && (
          <div className="loading">
            <img src={loadingImage} alt={loadingImage} className="mx-auto d-block loading-image" ></img>
          </div>
        )}
        <Meta
          title={title}
          keywords={keywords}
          description={description}
        />
        <Header />
        <main role="main">
          <div className="background">
            <div className="container">

              <div className="row">

                <div className="col-sm-10">
                  <h1 className='heading1'>{tutname} Interview Questions and Answers</h1>
                  {posts.map((post, i) => {
                    return (
                      <div className="container" style={{ paddingLeft: '0px', paddingRight: '0px' }} key={i}>
                        <div class="heading2">{post.topic_heading}</div>
                        <div class="content">
                          <pre>{post.topic_desc}</pre>
                        </div>
                      </div>
                    )
                  })}

                </div>
                <div className="col-sm-2">
                  <div class="thumbnail">
                    <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#c32324' }}>Tutorial</div>
                    <div>
                      <a href="/tutorial/php/1" class="rightdiv1">PHP Tutorial</a>
                    </div>
                    <div>
                      <a href="/tutorial/javascript/3" class="rightdiv1">Javascript Tutorial</a>
                    </div>
                    <div>
                      <a href="/tutorial/jquery/64" class="rightdiv1">Jquery Tutorial</a>
                    </div>
                    <div>
                      <a href="/tutorial/ajax/4" class="rightdiv1">Ajax Tutorial</a>
                    </div>
                    <div>
                      <a href="/tutorial/codeigniter/68" class="rightdiv1">Codeigniter Tutorial</a>
                    </div>
                    <div>
                      <a href="/tutorial/laravel/101" class="rightdiv1">Laravel Tutorial</a>
                    </div>
                    <div>
                      <a href="/tutorial/api/127" class="rightdiv1">API Tutorial</a>
                    </div>
                    <div>
                      <a href="/tutorial/react/137" class="rightdiv1">React Tutorial</a>
                    </div>
                      <div>
                      <a href="/tutorial/node/151" class="rightdiv1">Node Tutorial</a>
                    </div>
                    <br />
                    <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#c32324' }}>Example</div>
                    <div>
                      <a href="/example/php/1" class="rightdiv1">PHP Example</a>
                    </div>
                    <div>
                      <a href="/example/javascript/23" class="rightdiv1">Javascript Example</a>
                    </div>
                    <div>
                      <a href="/example/jquery/63" class="rightdiv1">Jquery Example</a>
                    </div>
                    <div>
                      <a href="/example/ajax/33" class="rightdiv1">Ajax Example</a>
                    </div>
                    <div>
                      <a href="/example/codeigniter/66" class="rightdiv1">Codeigniter Example</a>
                    </div>
                    <div>
                      <a href="/example/laravel/68" class="rightdiv1">Laravel Example</a>
                    </div>
                    <div>
                      <a href="/example/api/66" class="rightdiv1">API Example</a>
                    </div>
                    <div>
                      <a href="/example/api/66" class="rightdiv1">React Example</a>
                    </div>
                    <div>
                      <a href="/example/node/84" class="rightdiv1">Node Example</a>
                    </div>
                    <br />
                    <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#c32324' }}>Interview(Q/A)</div>
                    <div>
                      <a href="/interview/php" class="rightdiv1">PHP (Q/A)</a>
                    </div>
                    <div>
                      <a href="/interview/javascript" class="rightdiv1">Javascript (Q/A)</a>
                    </div>
                     <div>
                      <a href="/interview/ajax" class="rightdiv1">Ajax (Q/A)</a>
                    </div>
                     <div>
                      <a href="/interview/codeigniter" class="rightdiv1">Codeigniter (Q/A)</a>
                    </div>
                     <div>
                      <a href="/interview/laravel" class="rightdiv1">Laravel (Q/A)</a>
                    </div>
                     <div>
                      <a href="/interview/api" class="rightdiv1">API (Q/A)</a>
                    </div>
                     <div>
                      <a href="/interview/react" class="rightdiv1">React (Q/A)</a>
                    </div>
                     <div>
                      <a href="/interview/node" class="rightdiv1">Node (Q/A)</a>
                    </div>
                     <div>
                      <a href="/interview/javascriptchallenges" class="rightdiv1">JS challenges (Q/A)</a>
                    </div>
                     <div>
                      <a href="/interview/mongodb" class="rightdiv1">Mongo DB (Q/A)</a>
                    </div>
                     <div>
                      <a href="/interview/database" class="rightdiv1">Database (Q/A)</a>
                    </div>
                     <div>
                      <a href="/interview/techlead" class="rightdiv1">Tech Lead (Q/A)</a>
                    </div>
                    <div>
                      <a href="/interview/aws" class="rightdiv1">AWS (Q/A)</a>
                    </div>
                    <div>
                    {AdSenseAd250}
                    </div>

                  </div>
                </div>

              </div>
            </div>

          </div>
        </main>
        <Footer />
      </div>
    );
  }
}
export default Interview;
